<template>
  <section>
    <Toolbar />
    <div class="d-flex flex-column ma-0 pa-0 mt-md-5 mt-lg-5 mt-xl-5 px-5">
      <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <h3 class="texto-titulo text-center font-weight-bold">
            Confirma que tus datos personales sean correctos
          </h3>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-3">
        <v-col cols="12" class="ma-0 pa-0">
          <v-form>
            <v-container>
              <v-row justify="center">
                <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                  <v-text-field
                    readonly
                    outlined
                    v-model="persona.nombre"
                    label="Nombre"
                    required
                  ></v-text-field>

                  <v-text-field
                    readonly
                    outlined
                    v-model="persona.apellidoP"
                    label="Apellido Paterno"
                    required
                  ></v-text-field>

                  <v-text-field
                    readonly
                    outlined
                    v-model="persona.apellidoM"
                    label="Apellido Materno"
                    required
                  ></v-text-field>

                  <!-- <v-text-field
                    :readonly="!datosVerificados"
                    :error="!validCURP"
                    outlined
                    v-model="persona.curp"
                    label="CURP (agrega los ultimos 2 digitos)"
                    required
                    @keydown="changeCurp"
                    @change="changeCurp"
                  ></v-text-field> -->
                  <v-text-field
                    outlined
                    v-model="persona.curp"
                    label="CURP"
                    required
                    :error="!validCURP"
                    @change="changeCurp"
                  ></v-text-field>

                  <!-- <v-text-field
                    :readonly="!datosVerificados"
                    :error="!validRFC"
                    outlined
                    v-model="persona.rfc"
                    label="RFC (agrega tu homoclave, ultimos 3 caracteres)"
                    required
                    @keydown="changeRfc"
                    @change="changeRfc"
                  ></v-text-field> -->

                  <v-text-field
                    :error="!validRFC"
                    outlined
                    v-model="persona.rfc"
                    label="RFC"
                    required
                    @change="changeRfc"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0 d-flex justify-center align-center">
          <v-btn
            class="align-self-center mt-0"
            color="primary"
            elevation="2"
            :disabled="!(validCURP && validRFC)"
            @click="$router.push('datosDomicilio')"
            >CONFIRMAR<v-icon right light>mdi-arrow-right</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  components: {
    Toolbar,
  },
  mixins: [InsertaLogMixin],
  name: 'DatosPersonales',
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.$store.getters['persona/obtenerPersona'].tipoPersona != 2
      ? this.$router.push('cargaDocumentos')
      : ''
    this.persona = this.$store.getters['persona/obtenerPersona'].datosPersonales
    this.datosVerificados =
      this.$store.getters['persona/obtenerDatosVerificados']
    if (this.datosVerificados) {
      this.persona.curp = this.datosVerificados.Curp
      this.persona.rfc = this.datosVerificados.Rfc.trim()
      this.datosVerificados.Rfc = this.datosVerificados.Rfc.trim()
    }
  },
  data: () => ({
    // selectedItem: 0,
    persona: '',
    etapaProceso: 'Hazte socio',
    datosVerificados: null,
    validCURP: true,
    validRFC: true,
  }),
  methods: {
    changeCurp() {
      // console.log(
      //   // this.datosVerificados,
      //   // !this.persona.curp.length < 16
      //   'chanecurp',
      //   this.curp
      //   // ,
      //   // this.persona.curp.slice(0, 14) != this.datosVerificados.Curp
      // )
      //SE COMENTA PARA QUE NO DE PROBLEMAS
      // if (
      //   this.datosVerificados &&
      //   !this.persona.curp.length < 16 &&
      //   this.persona.curp.slice(0, 14) != this.datosVerificados.Curp
      // ) {
      //   this.persona.curp = this.datosVerificados.Curp
      //   this.validCURP = false
      // } else this.validCURP = true
      // if (this.persona.curp.length > 16) {
      //   this.persona.curp = this.persona.curp.slice(0, 15)
      // }
      // if (this.persona.curp.length < 16) {
      //   this.validCURP = false
      // }
      if (this.persona.curp.length > 16) {
        this.validCURP = true
      }
    },
    changeRfc() {
      // console.log('change rfc', this.persona.rfc)
      // if (
      //   this.datosVerificados &&
      //   !this.persona.rfc.length < 14 &&
      //   this.persona.rfc.slice(0, 13) != this.datosVerificados.Rfc
      // ) {
      //   this.persona.rfc = this.datosVerificados.Rfc
      //   this.validRFC = false
      // } else this.validRFC = true
      // if (this.persona.rfc.length > 16) {
      //   this.persona.rfc = this.persona.rfc.slice(0, 15)
      // }
      // if (this.persona.rfc.length < 16) {
      //   this.validRFC = false
      // }
      if (this.persona.rfc.length < 16) {
        this.validRFC = true
      }
    },
  },
}
</script>
